module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar2"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "ch01sub2"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("TERMS TO KNOW")])])]), _c('a', {
    attrs: {
      "id": "ch01sub2"
    }
  }), _c('h2', {
    staticClass: "h2tit"
  }, [_c('a', {
    attrs: {
      "id": "ch01sub2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Music Piece by Piece")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Music theory explores what has been done in other music in order to reach a greater overall understanding. Since you will see the language of written music throughout this book, you must be able to read it. You will need to read in multiple clefs, since standard notation uses treble and bass clefs at a minimum and often throws in alto clef too. Here is a basic review to help you make sense of what you are reading. There is also a somewhat detailed review of rhythms because it can be a difficult concept to understand; even if you know how to decipher the notes on a staff, you may still be uneasy with the counting aspect. If this chapter is already scaring you, you can get a brief tutorial on reading music in Chapters 9 and 10 of this book or you might want to pick up a book strictly on reading music and keep it around; it will help you greatly in understanding this material!")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("NOTES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What better place to start than with notes? Here’s a short sample of music; try to dissect what’s going on and see if you have all the information you need.")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_100",
    attrs: {
      "alt": "image",
      "src": "images/f0013-01.jpg"
    }
  })])]), _c('p', {
    staticClass: "noindentb"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("As you can see from this figure, this is a short excerpt from a piece of solo piano music. Here is what you are seeing:")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("1.")]), _vm._v(" There are notes placed on two musical staffs: one treble staff and one bass staff.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("2.")]), _vm._v(" The staffs are further defined by their clefs.")]), _vm._v(" "), _c('p', {
    staticClass: "numberb"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("3.")]), _vm._v(" The notes are identified only by use of a clef; otherwise, they are simply dots sitting on lines and spaces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you want to talk about the notes, you have to talk about clefs because clefs actually define the name of the notes in a staff.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("CLEFS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A clef is a symbol that sits at the beginning of every staff of music. A staff contains five lines and four spaces. How do you know where the note A or the note C is? The missing element is the clef, which defines what notes go where and functions a lot like a map. Placing a treble clef at the start of the staff defines the lines and spaces with note names. The following figure shows the notes of a treble staff.")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_100",
    attrs: {
      "alt": "image",
      "src": "images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The treble clef circles around the note G. This is why it’s commonly called the G clef. As for the notes, there is an important pattern. Look at the lowest line, which is designated E. Follow the musical alphabet to find where the next note is. The F is in the space just above the E. The staff ascends in this fashion—line, then space, then line—as it cycles through the musical alphabet (A–B–C–D–E–F–G).")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("The bass clef is a different clef than the treble and identifies not only different note names but also notes in different ranges. The bass clef is ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("used for instruments that have a lower pitch, like a bass guitar. Even though the bass clef sits on the same five-line staff, it defines very different notes. Many musicians can read treble clef because it is the most common clef. It is more difficult, however, for many musicians to read bass clef. In order to make progress in understanding theory, you will need to be adept at reading all clefs. The next figure shows the notes of a bass clef staff.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_100",
    attrs: {
      "alt": "image",
      "src": "images/f0015-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "boxhead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Notable")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr1"
  }), _vm._v(" "), _c('p', {
    staticClass: "boxtxt"
  }, [_vm._v("Even though you may understand the notes on both clefs, the only way to become proficient is to read other clefs as often as you can. Set aside a few minutes each day to look at other clefs so you can easily identify their notes. Since clefs define notes, think of being able to read in many clefs as a kind of musical literacy.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr2"
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("GRAND STAFF AND MIDDLE C")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Grouping the bass clef and the treble clef together creates ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("the grand staff. The grand staff is used in piano writing. To make a grand staff, connect a treble and a bass staff, or clef, with a brace, as shown in the following figure.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_50",
    attrs: {
      "alt": "image",
      "src": "images/f0015-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The grand staff reveals a very important note: middle C. The following figure shows a middle C.")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_50",
    attrs: {
      "alt": "image",
      "src": "images/f0016-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When you look at the previous figure, can you tell whether the note belongs to the bass clef or the treble clef? Actually, it belongs equally to both. If you trace down from the treble clef, one ledger line below the staff is a C. If you look at the bass clef notes, one ledger line above the staff is also a C. They are, in fact, the same pitch on the piano. This note is called middle C because it’s right in the middle of everything. Middle C will come up throughout this book, so keep track of it!")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("MOVABLE C CLEFS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The last type of clef is the C clef. Typically this clef is associated with the viola because it’s the most common instrument that reads in C clef; however, other instruments read it as well. When the C clef is used with the viola, it is called the alto clef. Thankfully, this clef is very easy to read; the symbol for the C clef has two semicircles that curve into the middle of the staff and basically point toward the middle line, which is a C—and it’s not just any C, it’s middle C. The next figure shows the notes for alto clef.")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_100",
    attrs: {
      "alt": "image",
      "src": "images/f0016-02.jpg"
    }
  })])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Since this is a movable clef, you can place the clef anywhere you want; whatever lines the two semicircles point to become middle C. Some ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("very old choral music uses a different movable C clef for each part (tenor clef, alto clef, and soprano clef). As long as you know that the clef always points toward middle C, you will be able to decipher the notes in this clef.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "boxhead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Notable")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr1"
  }), _vm._v(" "), _c('p', {
    staticClass: "boxtxt"
  }, [_vm._v("When notes use ledger lines that are extremely high or extremely low, they can be difficult to read; it’s much easier to read notes that sit in the staff you are reading. Using different clefs allows you to move the location of middle C so that the majority of your notes are in and around the staff.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr2"
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("ACCIDENTALS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Notes can be altered with the use of accidentals. If you’ve heard of B-flat (B♭) or C-sharp (C♯), then you’ve heard of an accidental. Accidentals are used to raise and lower the pitch of a tone. There are two types of accidentals: single and double.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A single accidental is the common ♭ and ♯ symbol.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A ♭ lowers the pitch by one half step.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A ♯ raises a pitch by one half step.")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_vm._v("• A ♮ (natural) cancels an accidental (either in a measure or from the given key signature).")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("In addition to the simple sharp and flat symbols, you will also see double accidentals.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/b.jpg"
    }
  }), _vm._v(" lowers the pitch by two half steps.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/x.jpg"
    }
  }), _vm._v(" raises a pitch by two half steps.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A ♮ cancels the double accidental in the same way it cancels the single accidentals.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-037951cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01b.vue
// module id = 78
// module chunks = 0